import React, { useState, useEffect, useRef } from 'react';

import ReactCardCarousel from 'react-card-carousel';
import { createRoot } from 'react-dom/client';
import CommarImage from '../assets/Comma_Carousel.svg';
import CommarImageWhite from '../assets/Comma_CarouselWhite.svg';
import Image1 from '../assets/hamza.jpg';
import Image2 from '../assets/kathy.jpeg';
import Image3 from '../assets/patrick.jpeg';
import { Box, Typography, Avatar, Rating } from '@mui/material';

// Container style
const containerStyle = {
  position: 'relative',
  // height: '442px',
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  paddingBottom: '24px',
  // borderRadius: '30px',
  // bgcolor: 'red',

  '@media (max-width:768px)': {
    height: '670px',
    gap: '100px',
  },
  '@media (max-width:500px)': {
    height: '650px',
    gap: '100px',
    // bgcolor: 'green',
  },
};

const carouselStyle = {
  borderRadius: '0px',
};

// Card style function
const cardStyle = (isActive) => ({
  width: isActive ? '100%' : '100%',
  height: isActive ? '90%' : '100%',
  padding: isActive ? '40px' : '20px',
  backgroundColor: isActive ? '#ffffff' : '#25a6d9',
  color: isActive ? '#000000' : '#ffffff',
  borderRadius: '30px',
  boxShadow: `0px 24px 48px -12px #1717172E`,
  display: 'flex',
  flexDirection: 'column',
  transition: 'background-color 0.3s ease, width 0.3s ease',
  outline: 'none',
  cursor: 'pointer',

  '@media (max-width:768px)': {
    width: isActive ? '90%' : '90%',
    height: isActive ? '450px' : '420px',
    padding: isActive ? '25px' : '15px',
  },
  '@media (max-width:500px)': {
    width: isActive ? '100%' : '100%',
    padding: isActive ? '18px' : '18px',
  },
});

const reviewHeaderStyle = {
  display: 'flex',
  alignItems: 'center',
  marginBottom: '15px',
};

// Review details style
const reviewDetailsStyle = {
  display: 'flex',
  flexDirection: 'column',
  marginLeft: '10px',
  gap: '4px',
};

// Dummy review data
const reviews = [
  {
    avatar: Image2,
    name: 'Kathy V.',
    rating: 5,
    location: 'Utah, USA',
    description: `Muhammad is really very pleasant and easy to work with. I find his work high quality and his experience is invaluable`,
  },
  {
    avatar: Image1,
    name: 'Hamza U.',
    rating: 5,
    location: 'Abu Dhabi, UAE',
    description: `He was able to complete the real estate website in a short period of time. He was very responsive and ensured he understood the instructions correctly. He was willing to make changes to improve the design. I will definitely hire him again`,
  },
  {
    avatar: Image3,
    name: 'Patrick M.',
    rating: 5,
    location: 'Arizona ,USA',
    description:
      'Muhammad not only met but exceeded expectations. His communication was good, he hit all deadlines ahead of schedule, and listened carefully to my requests while skillfully offering other spot-on ideas to bolster my branding message. I would have no hesitation in reaching out to Muhammad again for future projects.',
  },
];

// Carousel component
const MyCarousel = () => {
  const carouselRef = useRef(null);
  const [activeIndex, setActiveIndex] = useState(0);

  // useEffect(() => {
  //   const intervalId = setInterval(() => {
  //     setActiveIndex((prevIndex) => (prevIndex + 1) % reviews.length);
  //   }, 5000);
  //   return () => {
  //     clearInterval(intervalId);
  //   };
  // }, []);

  useEffect(() => {
    if (carouselRef.current) {
      carouselRef.current.goTo(activeIndex);
    }
  }, [activeIndex]);

  const handlePrevClick = () => {
    setActiveIndex(
      (prevIndex) => (prevIndex - 1 + reviews.length) % reviews.length
    );
  };

  const handleNextClick = () => {
    setActiveIndex((prevIndex) => (prevIndex + 1) % reviews.length);
  };

  const handleCardClick = (index) => {
    setActiveIndex(index);
  };

  return (
    <Box sx={containerStyle}>
      <Typography
        sx={{
          fontSize: '32px',
          fontWeight: '700',
          color: '#25a6d9',
          textAlign: 'center',
          marginBottom: '20px',
          fontFamily: 'Urbanist',
        }}
      >
        What People Say About Me
      </Typography>
      <ReactCardCarousel
        style={carouselStyle}
        ref={carouselRef}
        autoplay_speed={10000}
        autoplay={false}
        disable_box_shadow={true}
      >
        {reviews.map((review, index) => {
          const isActive = index === activeIndex;
          return (
            <Box
              key={index}
              sx={cardStyle(isActive)}
              onClick={() => {
                handleCardClick(index);
              }} // Set activeIndex on card click
            >
              <Box sx={reviewHeaderStyle}>
                <Avatar
                  src={review.avatar}
                  alt={review.name}
                  sx={{
                    width: 96,
                    height: 96,
                    marginRight: '10px',
                    border: `5px solid ${isActive ? '#D6E0FB' : '#ffffff'}`,
                    transition: 'border-color 0.10s ease',
                    '@media only screen and (max-width:768px)': {
                      width: '60px',
                      height: '60px',
                    },
                  }}
                />
                <Box sx={reviewDetailsStyle}>
                  <Typography
                    sx={{
                      fontWeight: 700,
                      color: isActive ? '#000000' : '#fff',
                      fontSize: '20px',
                      fontFamily: 'Urbanist',
                      '@media only screen and (max-width:768px)': {
                        fontSize: '16px',
                      },
                    }}
                  >
                    {review.name}
                  </Typography>
                  <Rating
                    name={`rating-${index}`}
                    value={review.rating}
                    readOnly
                    precision={0.5}
                    sx={{
                      '& .MuiRating-icon': {
                        color: isActive ? '#FFD700' : '#FFD700',
                        transition: 'color 0.3s ease',
                      },
                      '& .MuiRating-iconFilled': {
                        color: isActive ? '#FFD700' : '#FFD700',
                      },
                      '& .MuiRating-iconEmpty': {
                        color: '#B0B0B0',
                      },
                      '@media only screen and (max-width:768px)': {
                        '& .MuiRating-icon': {
                          fontSize: '1rem',
                        },
                      },
                    }}
                  />
                  <Typography
                    sx={{
                      fontWeight: 500,
                      fontSize: '16px',
                      color: isActive ? '#7C8CE2' : '#fff',
                      fontFamily: 'Urbanist',
                      '@media only screen and (max-width:768px)': {
                        fontSize: '12px',
                      },
                    }}
                  >
                    {review.location}
                  </Typography>
                </Box>
              </Box>
              <Typography
                sx={{
                  fontWeight: 500,
                  fontSize: '20px',
                  color: isActive ? '#828282' : '#fff',
                  fontFamily: 'Urbanist',
                  '@media only screen and (max-width:768px)': {
                    fontSize: '16px',
                  },
                }}
              >
                {review.description}
              </Typography>
              <Box
                width={'100%'}
                marginTop={'15px'}
                height="100%"
                display="flex"
                alignItems="flex-end"
                justifyContent="flex-end"
              >
                <Box
                  component="img"
                  sx={{
                    width: '67px',
                    height: '67px',
                    float: 'right',
                    '@media only screen and (max-width:768px)': {
                      width: '30px',
                      height: '30px',
                    },
                  }}
                  src={isActive ? CommarImage : CommarImageWhite}
                  alt="Image"
                />
              </Box>
            </Box>
          );
        })}
      </ReactCardCarousel>
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        mt={'490px'}
        gap={'5px'}
        sx={{
          '@media (max-width:768px)': {
            marginTop: '0',
          },
        }}
      >
        <Box
          width={'20px'}
          height={'20px'}
          borderRadius={'14px'}
          bgcolor={'#A6A6A6'}
          onClick={handlePrevClick}
          sx={{ cursor: 'pointer' }}
        />
        <Box
          width={'87px'}
          height={'20px'}
          borderRadius={'14px'}
          bgcolor={'#25a6d9'}
        />
        <Box
          width={'20px'}
          height={'20px'}
          borderRadius={'14px'}
          bgcolor={'#A6A6A6'}
          onClick={handleNextClick}
          sx={{ cursor: 'pointer' }}
        />
      </Box>
    </Box>
  );
};

export default MyCarousel;

const rootElement = document.getElementById('root');
const root = createRoot(rootElement);
root.render(<MyCarousel />);
